import { getModel } from "core-web/state";
import { put } from "core-web/libs/GrebbCommerceAPI/util";
import tracking from "core-web/components/Tracking";

export default async (basketId, lineNo, quantity, eventId) => {
    const clientId = tracking.getClientId();
    const sessionId = tracking.getSessionId();
    const eventTimestamp = tracking.getEventTimestamp();
    const consentMarketing = tracking.getConsentMarketing();
    const consentStatistic = tracking.getConsentStatistic();
    const fbp = tracking.getFacebookFbp();
    const fbc = tracking.getFacebookFbc();
    const clientUserAgent = tracking.getFacebookClientUserAgent() || "";
    const clientIpAddress = getModel("application").ipAddress;

    const data = {
        application_id: getModel("application").applicationId,
        quantity,
        consent_marketing: consentMarketing,
        consent_statistic: consentStatistic,
    };

    if (clientId) {
        data["tracking_client_id"] = clientId;
    }

    if (sessionId) {
        data["tracking_session_id"] = sessionId;
    }

    if (eventTimestamp) {
        data["tracking_event_timestamp"] = eventTimestamp;
    }

    if (fbp) {
        data["tracking_fbp"] = fbp;
    }

    if (fbc) {
        data["tracking_fbc"] = fbc;
    }

    if (clientUserAgent) {
        data["tracking_client_user_agent"] = clientUserAgent;
    }

    if (clientIpAddress) {
        data["tracking_client_ip_address"] = clientIpAddress;
    }

    if (eventId) {
        data["tracking_event_id"] = eventId;
    }

    const response = await put(`/frontend/basket/${basketId}/package/${lineNo}`, data);

    return await response.body();
};
